import moment from 'moment';

export const formatLastSync = (date) => {
  if (!date) return 'N/A';

  const mDate = moment(date);

  // If it's today, explicitly show "Today" + time
  if (mDate.isSame(moment(), 'day')) {
    return `Today at ${mDate.format('hh:mm A')}`;
  }

  // If it's yesterday
  if (mDate.isSame(moment().subtract(1, 'day'), 'day')) {
    return `Yesterday at ${mDate.format('hh:mm A')}`;
  }

  // If it's within the last 7 days, show weekday name
  if (mDate.isAfter(moment().subtract(7, 'days'))) {
    return `${mDate.format('dddd')} at ${mDate.format('hh:mm A')}`;
  }

  return mDate.fromNow();
};
